"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @hidden
 *
 * An object which contains the information about the cities within the timezone.
 */
exports.timezones = {
    rules: {},
    titles: {},
    zones: {}
};



//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-date-math@1.5.14/~/@progress/kendo-date-math/dist/npm/tz/timezones.js
// module id = 68
// module chunks = 0